import client from './client';

export interface DashboardAsset {
  id: string;
  url: string;
  name: string;
  size: number;
  type: string;
  userId: string;
  createdAt: string;
  /** 资产大类：image / model / template / font（D-01） */
  assetType?: string;
  /** private=仅本人 / tenant=本租户共享（D-02） */
  visibility?: string;
  tenantId?: string;
}

/** 大屏资源上传：背景图/组件图片/模型/模板/字体，返回可通过 /uploads 访问的 URL */
export async function uploadDashboardAsset(
  file: File,
  opts?: { assetType?: string; visibility?: 'private' | 'tenant' },
): Promise<DashboardAsset> {
  const formData = new FormData();
  formData.append('file', file);
  if (opts?.assetType) formData.append('assetType', opts.assetType);
  if (opts?.visibility) formData.append('visibility', opts.visibility);
  // FormData 由浏览器自动设 Content-Type（含 boundary），不要手动覆盖
  const { data } = await client.post('/dashboard-assets/upload', formData, { timeout: 60000 });
  return data;
}

/** 资源库列表：我的素材 + 共享到本租户（关键字/类型/资产大类过滤） */
export async function listDashboardAssets(keyword?: string, type?: string, assetType?: string): Promise<DashboardAsset[]> {
  const { data } = await client.get('/dashboard-assets/list', {
    params: { keyword: keyword || undefined, type: type || undefined, assetType: assetType || undefined },
  });
  return (data as { list: DashboardAsset[] }).list;
}

/** 删除素材（资源库管理） */
export async function deleteDashboardAsset(id: string): Promise<void> {
  await client.delete(`/dashboard-assets/${id}`);
}